import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Link, withRouter} from 'react-router-dom';
import {translate} from 'react-i18next';
import onClickOutside from 'react-onclickoutside';
import {clickOutsideConfig} from '../../../helpers';


class ProfileMenuView extends Component {

  constructor(props) {
    super(props);
    this.showPersonalAccount = this.showPersonalAccount.bind(this);
    this.exitPersonalAccount = this.exitPersonalAccount.bind(this);
    this.displayPersonalAccount = this.displayPersonalAccount.bind(this);
    this.onClickLogin = this.onClickLogin.bind(this);
    this.getUserFullName = this.getUserFullName.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = {
      isShowPersonalAccount: false
    }
  }

  showPersonalAccount() {
    this.setState({
      isShowPersonalAccount: !this.state.isShowPersonalAccount
    });
  }

  exitPersonalAccount(event) {
    event.preventDefault();
    const {exitCustomer, history, selected, language} = this.props;
    exitCustomer();
    this.setState({
      isShowPersonalAccount: !this.state.isShowPersonalAccount
    });
    history.replace(`/${language}/${selected.name_for_url}/products/pizza`);
  }

  displayPersonalAccount() {
    this.setState({
      isShowPersonalAccount: !this.state.isShowPersonalAccount
    });
  }

  onClickLogin() {
    this.props.openAuthModal();
  }

  getUserFullName(customer) {
    return customer.first_name + ' ' + customer.last_name;
  }

  handleClickOutside() {
    this.setState({
      isShowPersonalAccount: false,
    });
  };

  render() {
    const {customer, t, language} = this.props;
    const {getUserFullName} = this;
    const {isShowPersonalAccount} = this.state;
    return (
      <div className='page-header__reorder--profile-menu'>
        {!!Object.keys(customer).length ?
          <div className='page-header__personal-account-wrapper'>
            <button
              className='page-header__personal-account'
              onClick={this.showPersonalAccount}
            >
              {getUserFullName(customer)}
            </button>
            {isShowPersonalAccount &&
            <div className="page-header__personal-account-menu">
              <Link
                to={{
                  pathname: `/${language}/profile`,
                  state: {
                    path: 'profile'
                  }
                }}
                onClick={this.displayPersonalAccount}
              >
                <span>{t('profile')}</span>
              </Link>
              <Link
                to='#'
                onClick={this.exitPersonalAccount}
              >{t('exit')}</Link>
            </div>
            }
          </div>
          :
          <Link to="#" onClick={this.onClickLogin}>
            <span>{t('log_in')}</span>
          </Link>
        }
      </div>
    );
  }
}

ProfileMenuView.propTypes = {
  customer: PropTypes.object,
  openAuthModal: PropTypes.func,
  exitCustomer: PropTypes.func,
};

export default withRouter(translate('translations')(onClickOutside(ProfileMenuView, clickOutsideConfig)));



// WEBPACK FOOTER //
// ./src/components/Customer/Profile/ProfileMenuView.js